import { HttpApiEndpoint, HttpApiError, HttpApiGroup } from "@effect/platform";
import { Schema } from "effect";
import {
  DatabaseError,
  DataIntegrityError,
  OpenSearchError,
} from "../auth/errors";
import { Authorization } from "../auth/middleware";

const GetConversationCountsInput = Schema.Struct({
  views: Schema.Array(
    Schema.Struct({
      viewKey: Schema.String,
      filterGroup: Schema.NullOr(Schema.String),
    }),
  ),
});

export const ConversationCountsGroup = HttpApiGroup.make("conversationCounts")
  .add(
    HttpApiEndpoint.post("getConversationCounts", "/conversation-counts")
      .middleware(Authorization)
      .setPayload(GetConversationCountsInput)
      .addSuccess(Schema.Record({ key: Schema.String, value: Schema.Number }))
      .addError(HttpApiError.Forbidden)
      .addError(OpenSearchError)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api");
